import Swiper, { Navigation, Pagination, Lazy, Scrollbar } from 'swiper';
import 'swiper/css';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initializeSlider(containerId) {
    const containerSlider = $(containerId);

    const swiperPosts = new Swiper(containerId + ' .swiper-no-padding', {
        modules: [Navigation, Pagination, Scrollbar, Lazy],

        slidesPerView: 'auto',
        loop: true,
        effect: 'slide',

        breakpoints: {
            0: {
                spaceBetween: 8,
                effect: 'slide',
            },
            //md
            768: {
                spaceBetween: 20,
            },
        },

        pagination: {
            el: containerId + ' .swiper-pagination',
            type: 'progressbar',
        },

        lazy: {
            enabled: true,
            loadPrevNext: true,
            loadPrevNextAmount: 4,
        },

        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
        on: {
            slideChangeTransitionEnd: function () {
                document.querySelectorAll('.swiper-slide').forEach((slide) => {
                    if (slide.classList.contains('swiper-slide-active')) {
                        slide.classList.add('active-slide');
                    } else {
                        slide.classList.remove('active-slide');
                    }
                    slide.addEventListener('transitionend', (event) => {
                        if (event.propertyName === 'width') {
                            slide.classList.add('transition-end');
                        }
                    });

                    slide.addEventListener('transitionstart', () => {
                        slide.classList.remove('transition-end');
                    });
                });
            },
        },
    });

    swiperPosts.on('slideChange', function () {
        // containerSlider.find('.slider-current-page').html((this.realIndex + 1).toString().padStart(2, '0'));
        containerSlider.find('.slider-current-page').html('01');
        containerSlider.find('.slider-progress .progress-fill').css('width', Math.min(this.progress * 100, 100) + '%');
    });
}

$('.slider-history-video').each(function () {
    initializeSlider('#' + $(this).attr('id'));
});


